import { showError } from "./UI";

export async function fetchRepos() {
  const url = "https://api.github.com/users/franchuphone/repos";

  try {
    const request = new Request(url);
    const response = await fetch(request);
    if (!response.ok) {
      throw new Error(`Error fetching Github repositories`);
    }
    const repos = await response.json();
    return filterRepos(repos);
  } catch (error) {
    console.error("Fetch Error: ", error);
    showError("Problem with repositories");
    if (error.response) {
      error.response.text().then((errorMessage) => {
        showError("Connectivity issue, try again");
        console.error("Error Details:", errorMessage);
      });
    }
  }
}

function filterRepos(data) {
  const pinned = [
      "battleship",
      "weather-app",
      "sketchpad",
      "todo-list",
      "nothing",
    ],
    fields = ["name", "description", "html_url", "homepage", "topics"],
    repos = data.filter((repo) => pinned.includes(repo.name)),
    projects = repos.map((repo) =>
      Object.fromEntries(fields.map((f) => [f, repo[f]])),
    );
  projects.map((project) => (project.name = cleanName(project)));
  return projects;
}

function cleanName(project) {
  project.name = project.name.charAt(0).toUpperCase() + project.name.slice(1);
  return project.name.split("-").join(" ");
}
